import { useState, useEffect } from 'react';

const anchors = [
  { label: 'HOME', href: '#home' },
  { label: 'SERVICES', href: '#services' },
  { label: 'FLOW', href: '#flow' },
  { label: 'ABOUT US', href: '#about' },
  { label: 'CLIENTS', href: '#clients' },
  { label: 'FAQ', href: '#faq' },
  { label: 'CONTACT', href: '#contact' },
];

const sectionIds = ['home', 'services', 'flow', 'about', 'clients', 'faq', 'contact'];

export default function AnchorMenu() {
  const [active, setActive] = useState('home');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { threshold: 0.35 }
    );
    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="fixed right-5 top-1/2 -translate-y-1/2 z-40 hidden lg:flex flex-col gap-3">
      {anchors.map((item) => {
        const id = item.href.replace('#', '');
        const isActive = active === id;
        return (
          <button
            key={item.label}
            onClick={() => handleClick(item.href)}
            className="group flex items-center gap-2.5 cursor-pointer"
            title={item.label}
          >
            <span className="text-white text-[10px] tracking-widest opacity-0 group-hover:opacity-70 transition-opacity duration-200 whitespace-nowrap font-['Montserrat']">
              {item.label}
            </span>
            <span
              className={`block rounded-full transition-all duration-300 ${
                isActive
                  ? 'w-2.5 h-2.5 bg-white'
                  : 'w-1.5 h-1.5 bg-white/35 group-hover:bg-white/65'
              }`}
            />
          </button>
        );
      })}
    </nav>
  );
}
